var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNonFactoring(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2078_111747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 2H11.15C10.82 0.85 9.76 0 8.5 0C7.24 0 6.18 0.85 5.85 2H4.75C4.34 2 4 2.34 4 2.75V4.25C4 5.21 4.79 6 5.75 6H11.25C12.21 6 13 5.21 13 4.25V2.75C13 2.34 12.66 2 12.25 2Z",
    fill: "#D72525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 3H14V4.25C14 5.77 12.77 7 11.25 7H5.75C4.23 7 3 5.77 3 4.25V3H2.75C1.23 3 0 4.23 0 5.75V18.25C0 19.77 1.23 21 2.75 21H9.34C8.84 19.93 8.54 18.75 8.51 17.5H3.75C3.34 17.5 3 17.16 3 16.75C3 16.34 3.34 16 3.75 16H8.59C8.68 15.39 8.83 14.81 9.03 14.25H3.75C3.34 14.25 3 13.91 3 13.5C3 13.09 3.34 12.75 3.75 12.75H9.75C10.14 12.11 10.6 11.52 11.14 11H3.75C3.34 11 3 10.66 3 10.25C3 9.84 3.34 9.5 3.75 9.5H13.19C14.34 8.9 15.63 8.54 17 8.51V5.75C17 4.23 15.77 3 14.25 3Z",
    fill: "#D72525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 24C20.972 24 24 20.972 24 17.25C24 13.528 20.972 10.5 17.25 10.5C13.528 10.5 10.5 13.528 10.5 17.25C10.5 20.972 13.528 24 17.25 24ZM16.25 14.5C16.25 13.948 16.697 13.5 17.25 13.5C17.803 13.5 18.25 13.948 18.25 14.5L18.25 18C18.25 18.552 17.803 19 17.25 19C16.697 19 16.25 18.552 16.25 18L16.25 14.5ZM17.25 19.5C17.802 19.5 18.25 19.948 18.25 20.5C18.25 21.052 17.802 21.5 17.25 21.5C16.698 21.5 16.25 21.052 16.25 20.5C16.25 19.948 16.698 19.5 17.25 19.5Z",
    fill: "#D72525"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2078_111747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonFactoring);
export default __webpack_public_path__ + "static/media/nonFactoring.05427a36e357b4d8ace4262c402e85c6.svg";
export { ForwardRef as ReactComponent };